export default __webpack_public_path__ + "static/media/password-16px.ac65b9d6.svg";